import client from './index'

const getData = () => client['api'].get(`dashboard`)

export {
    getData
}